export default function PageHeader({ children }) {
  return (
    <h1 className="text-2xl  text-slate-800 font-semibold">
      {/* <h1 className="text-xl  text-slate-800 font-bold"> */}
      {children}
    </h1>
  );
}
